<div class="wetter_content_container">
  <div class="bericht-text-container">
    <h3>{{siebentageWetterbericht?.caption_wx_text}}</h3>
    {{siebentageWetterbericht?.wx_text}}
  </div>
  <div class="bericht-text-container">
    {{siebentageWetterbericht?.footer}}
  </div>
</div>
